// App.jsx
// 顶层布局: TopBar / (Sidebar | Content | RightPanel) / StatusBar
// 状态在 SolPredProvider 里, 这里只是组装

import { SolPredProvider, useSolPred } from './hooks/useSolPredStore';
import TopBar      from './components/layout/TopBar';
import Sidebar     from './components/layout/Sidebar';
import MetaBar     from './components/layout/MetaBar';
import RightPanel  from './components/layout/RightPanel';
import StatusBar   from './components/layout/StatusBar';
import IsothermalTab  from './components/tabs/IsothermalTab';
import Scatter3DTab   from './components/tabs/Scatter3DTab';
import Surface3DTab   from './components/tabs/Surface3DTab';
import DiagnosticsTab from './components/tabs/DiagnosticsTab';
import DataTab        from './components/tabs/DataTab';
import PredictTab     from './components/tabs/PredictTab';

function TabBar() {
  const { activeTab, setActiveTab, tabs } = useSolPred();
  return (
    <div className="tabbar">
      {tabs.map(tab => (
        <div
          key={tab.id}
          className={`tab ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => setActiveTab(tab.id)}
        >
          <span className="tab-icon">{tab.icon}</span>
          <span>{tab.label}</span>
          <span className="tab-desc">{tab.desc}</span>
        </div>
      ))}
    </div>
  );
}

function TabContent() {
  const { activeTab } = useSolPred();
  // 路由式分发: 哪个 tab 激活就渲染哪个组件
  switch (activeTab) {
    case 'isothermal':  return <IsothermalTab />;
    case 'scatter3d':   return <Scatter3DTab />;
    case 'surface3d':   return <Surface3DTab />;
    case 'diagnostics': return <DiagnosticsTab />;
    case 'data':        return <DataTab />;
    case 'predict':     return <PredictTab />;
    default:            return <IsothermalTab />;
  }
}

function Layout() {
  return (
    <div className="solpred-root">
      <TopBar />
      <div className="main">
        <Sidebar />
        <div className="content">
          <MetaBar />
          <TabBar />
          <div className="workspace">
            <div className="canvas-area">
              <TabContent />
            </div>
            <RightPanel />
          </div>
          <StatusBar />
        </div>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <SolPredProvider>
      <Layout />
    </SolPredProvider>
  );
}
